/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="486" height="487" viewBox="0 0 486 487" fill="none"> <desc id="IMP.BLUE">{"#Link":{"type":"SELECTOR","constraint":"none","width":486,"height":486.56048583984375},"#Vector":{"type":"SELECTOR","constraint":"xMidYMid meet","width":315,"height":410},"transforms":{}}</desc>
 * <g id="Link">
 * <path id="Vector" d="M348.992 276.173C355.51 287.167 357.36 300.097 354.165 312.524C350.967 324.966 343.101 335.414 332.017 341.941L188.884 426.125C177.461 432.852 164.352 434.31 152.413 431.244C140.481 428.177 129.715 420.584 122.962 409.194L73.2748 325.414C66.7215 314.367 64.8747 301.438 68.0695 289.011C71.2681 276.568 79.1334 266.123 90.2184 259.594C90.3746 259.502 90.537 259.411 90.6986 259.323L108.249 249.782C116.025 245.558 125.76 248.432 129.994 256.199C134.228 263.967 131.36 273.691 123.583 277.915L106.314 287.306C102.717 289.488 100.166 292.921 99.1192 296.993C98.0569 301.125 98.6743 305.428 100.853 309.101L150.541 392.881C155.056 400.498 164.952 403.033 172.597 398.529L315.729 314.344C319.421 312.17 322.047 308.685 323.113 304.541C324.175 300.408 323.56 296.11 321.381 292.433L272.166 208.729C267.678 201.168 257.785 198.634 250.142 203.135L230.469 214.844C222.864 219.371 213.025 216.877 208.492 209.281C203.959 201.682 206.443 191.856 214.048 187.329L233.785 175.582C256.687 162.091 286.265 169.685 299.776 192.47L348.992 276.173ZM411.89 160.104L362.203 76.3237C348.691 53.5394 319.113 45.9453 296.289 59.3853L153.184 143.438C142.099 149.968 134.234 160.412 131.035 172.855C127.841 185.282 129.687 198.211 136.238 209.258L185.925 293.038C192.683 304.432 203.455 312.026 215.39 315.095C227.319 318.161 240.411 316.705 251.804 309.996L271.81 298.312C279.453 293.853 282.022 284.046 277.554 276.409C273.082 268.774 263.264 266.201 255.624 270.661L235.563 282.373C227.918 286.877 218.022 284.342 213.507 276.725L163.819 192.945C161.641 189.269 161.023 184.969 162.085 180.837C163.151 176.693 165.776 173.208 169.461 171.038L312.566 86.9855C320.213 82.4852 330.107 85.0159 334.625 92.6337L384.309 176.413C386.491 180.09 387.106 184.389 386.043 188.524C385.016 192.517 382.541 195.896 379.051 198.086L362.323 206.417C354.403 210.359 351.187 219.975 355.141 227.89C359.091 235.807 368.718 239.025 376.639 235.08L393.956 226.457C394.29 226.288 394.62 226.112 394.944 225.92C406.029 219.394 413.895 208.946 417.093 196.507C420.288 184.076 418.441 171.148 411.89 160.104V160.104Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Link": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 486,
 * 		"height": 486.56048583984375
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMidYMid meet",
 * 		"width": 315,
 * 		"height": 410
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Link = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
  linkColor?: string;
}): JSX.Element => {
  const {
    style = {
      width: 486,
      height: 487,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    linkColor = "white",
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} style={svgStyle}>
          <G id="Link">
            <Svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 486 487">
              <Path
                id="Vector"
                d="M348.992 276.173C355.51 287.167 357.36 300.097 354.165 312.524C350.967 324.966 343.101 335.414 332.017 341.941L188.884 426.125C177.461 432.852 164.352 434.31 152.413 431.244C140.481 428.177 129.715 420.584 122.962 409.194L73.2748 325.414C66.7215 314.367 64.8747 301.438 68.0695 289.011C71.2681 276.568 79.1334 266.123 90.2184 259.594C90.3746 259.502 90.537 259.411 90.6986 259.323L108.249 249.782C116.025 245.558 125.76 248.432 129.994 256.199C134.228 263.967 131.36 273.691 123.583 277.915L106.314 287.306C102.717 289.488 100.166 292.921 99.1192 296.993C98.0569 301.125 98.6743 305.428 100.853 309.101L150.541 392.881C155.056 400.498 164.952 403.033 172.597 398.529L315.729 314.344C319.421 312.17 322.047 308.685 323.113 304.541C324.175 300.408 323.56 296.11 321.381 292.433L272.166 208.729C267.678 201.168 257.785 198.634 250.142 203.135L230.469 214.844C222.864 219.371 213.025 216.877 208.492 209.281C203.959 201.682 206.443 191.856 214.048 187.329L233.785 175.582C256.687 162.091 286.265 169.685 299.776 192.47L348.992 276.173ZM411.89 160.104L362.203 76.3237C348.691 53.5394 319.113 45.9453 296.289 59.3853L153.184 143.438C142.099 149.968 134.234 160.412 131.035 172.855C127.841 185.282 129.687 198.211 136.238 209.258L185.925 293.038C192.683 304.432 203.455 312.026 215.39 315.095C227.319 318.161 240.411 316.705 251.804 309.996L271.81 298.312C279.453 293.853 282.022 284.046 277.554 276.409C273.082 268.774 263.264 266.201 255.624 270.661L235.563 282.373C227.918 286.877 218.022 284.342 213.507 276.725L163.819 192.945C161.641 189.269 161.023 184.969 162.085 180.837C163.151 176.693 165.776 173.208 169.461 171.038L312.566 86.9855C320.213 82.4852 330.107 85.0159 334.625 92.6337L384.309 176.413C386.491 180.09 387.106 184.389 386.043 188.524C385.016 192.517 382.541 195.896 379.051 198.086L362.323 206.417C354.403 210.359 351.187 219.975 355.141 227.89C359.091 235.807 368.718 239.025 376.639 235.08L393.956 226.457C394.29 226.288 394.62 226.112 394.944 225.92C406.029 219.394 413.895 208.946 417.093 196.507C420.288 184.076 418.441 171.148 411.89 160.104V160.104Z"
                fill={linkColor}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 486 487"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M348.992 276.173C355.51 287.167 357.36 300.097 354.165 312.524C350.967 324.966 343.101 335.414 332.017 341.941L188.884 426.125C177.461 432.852 164.352 434.31 152.413 431.244C140.481 428.177 129.715 420.584 122.962 409.194L73.2748 325.414C66.7215 314.367 64.8747 301.438 68.0695 289.011C71.2681 276.568 79.1334 266.123 90.2184 259.594C90.3746 259.502 90.537 259.411 90.6986 259.323L108.249 249.782C116.025 245.558 125.76 248.432 129.994 256.199C134.228 263.967 131.36 273.691 123.583 277.915L106.314 287.306C102.717 289.488 100.166 292.921 99.1192 296.993C98.0569 301.125 98.6743 305.428 100.853 309.101L150.541 392.881C155.056 400.498 164.952 403.033 172.597 398.529L315.729 314.344C319.421 312.17 322.047 308.685 323.113 304.541C324.175 300.408 323.56 296.11 321.381 292.433L272.166 208.729C267.678 201.168 257.785 198.634 250.142 203.135L230.469 214.844C222.864 219.371 213.025 216.877 208.492 209.281C203.959 201.682 206.443 191.856 214.048 187.329L233.785 175.582C256.687 162.091 286.265 169.685 299.776 192.47L348.992 276.173ZM411.89 160.104L362.203 76.3237C348.691 53.5394 319.113 45.9453 296.289 59.3853L153.184 143.438C142.099 149.968 134.234 160.412 131.035 172.855C127.841 185.282 129.687 198.211 136.238 209.258L185.925 293.038C192.683 304.432 203.455 312.026 215.39 315.095C227.319 318.161 240.411 316.705 251.804 309.996L271.81 298.312C279.453 293.853 282.022 284.046 277.554 276.409C273.082 268.774 263.264 266.201 255.624 270.661L235.563 282.373C227.918 286.877 218.022 284.342 213.507 276.725L163.819 192.945C161.641 189.269 161.023 184.969 162.085 180.837C163.151 176.693 165.776 173.208 169.461 171.038L312.566 86.9855C320.213 82.4852 330.107 85.0159 334.625 92.6337L384.309 176.413C386.491 180.09 387.106 184.389 386.043 188.524C385.016 192.517 382.541 195.896 379.051 198.086L362.323 206.417C354.403 210.359 351.187 219.975 355.141 227.89C359.091 235.807 368.718 239.025 376.639 235.08L393.956 226.457C394.29 226.288 394.62 226.112 394.944 225.92C406.029 219.394 413.895 208.946 417.093 196.507C420.288 184.076 418.441 171.148 411.89 160.104V160.104Z"
          fill={linkColor}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(Link);
